import React from 'react';
import { Modal } from '../ui/Modal';

/**
 * The cart's "log in first" question — a ui/Modal `confirm` (R5 desktop
 * standard rule 5; UI leftovers C3, 2026-11-03). It was a react-bootstrap
 * <Modal>; the words and the three acts are the same. The variant's own
 * footer draws the row: Cancel and Sign Up are the ordinary (secondary)
 * acts, Log In is the dialog's ONE primary (Design System v1 §2.2) — the
 * same pairing as the header, where Login and Sign up are told apart by
 * which one is the main act. `footer` is passed (not `primaryAction`)
 * because this question has THREE answers, and the variant draws only
 * Cancel + one primary by itself.
 *
 * The variant's sheet scrolls its body under a sticky header, so a short
 * phone keeps the "Login Required" title on screen (the 2026-08-12 Cowork
 * re-sweep that once needed react-bootstrap's `scrollable`).
 */
const LoginRequiredDialog = ({ show, onClose, onConfirm, onSignUp }) => (
  <Modal
    isOpen={Boolean(show)}
    onClose={onClose}
    variant="confirm"
    title="Login Required"
    modalId="login-required-dialog"
    footer={(
      <>
        <button type="button" className="ff-btn ff-btn--secondary" onClick={onClose}>
          Cancel
        </button>
        <button type="button" className="ff-btn ff-btn--secondary" onClick={onSignUp}>
          Sign Up
        </button>
        <button type="button" className="ff-btn ff-btn--primary" onClick={onConfirm}>
          Log In
        </button>
      </>
    )}
  >
    <p>You must be logged in to proceed to checkout.</p>
    <p>We require login to confirm your email address so we can coordinate your shipping schedule after checkout.</p>
  </Modal>
);

export default LoginRequiredDialog;
